import styled from 'styled-components';

export const TableActions = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;